// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"SnackBar_snackbar__3mDUA","close":"SnackBar_close__28K3_","message":"SnackBar_message__1TP03"};